import { RoutePath } from "../types";

export const NSW_HOME_ROUTES = [
  RoutePath.SIMPLE_DETAILS,
  RoutePath.CHOOSE_FLOOR_PLAN,
  RoutePath.CHOOSE_STREET_APPEAL,
  RoutePath.CHOOSE_EXTERIOR_STYLE,
  RoutePath.INTERIOR_STYLE,
  RoutePath.PROMOTIONS,
  RoutePath.UPGRADE_OPTIONS,
  RoutePath.SPECIAL_OFFERS,
  RoutePath.FINAL_DETAILS,
  RoutePath.YOUR_NEW_HOME,
];

export const NSW_HOME_ROUTES_WITH_SIMPLE_DETAILS = [
  RoutePath.SIMPLE_DETAILS,
  RoutePath.CHOOSE_FLOOR_PLAN,
  RoutePath.CHOOSE_STREET_APPEAL,
  RoutePath.CHOOSE_EXTERIOR_STYLE,
  RoutePath.INTERIOR_STYLE,
  RoutePath.PROMOTIONS,
  RoutePath.UPGRADE_OPTIONS,
  RoutePath.SPECIAL_OFFERS,
  RoutePath.FINAL_DETAILS,
  RoutePath.YOUR_NEW_HOME,
];

export const NSW_HOME_KIOSK_ROUTES = [
  RoutePath.CHOOSE_FLOOR_PLAN,
  RoutePath.CHOOSE_STREET_APPEAL,
  RoutePath.CHOOSE_EXTERIOR_STYLE,
  RoutePath.INTERIOR_STYLE,
  RoutePath.PROMOTIONS,
  RoutePath.UPGRADE_OPTIONS,
  RoutePath.SPECIAL_OFFERS,
  RoutePath.YOUR_NEW_HOME,
  RoutePath.FINAL_DETAILS,
  RoutePath.THANK_YOU,
];

export const NSW_HOUSE_LAND_ROUTES = [
  RoutePath.PACKAGE_SEARCH,
  RoutePath.PACKAGE_SEARCH_RESULTS,
  RoutePath.PACKAGE_DETAILS,
  RoutePath.CHOOSE_EXTERIOR_STYLE,
  RoutePath.INTERIOR_STYLE,
  RoutePath.PROMOTIONS,
  RoutePath.UPGRADE_OPTIONS,
  RoutePath.SPECIAL_OFFERS,
  RoutePath.FINAL_DETAILS,
  RoutePath.YOUR_NEW_HOME,
];

export const NSW_HOUSE_LAND_KIOSK_ROUTES = [
  RoutePath.PACKAGE_SEARCH,
  RoutePath.PACKAGE_SEARCH_RESULTS,
  RoutePath.PACKAGE_DETAILS,
  RoutePath.CHOOSE_EXTERIOR_STYLE,
  RoutePath.INTERIOR_STYLE,
  RoutePath.PROMOTIONS,
  RoutePath.UPGRADE_OPTIONS,
  RoutePath.SPECIAL_OFFERS,
  RoutePath.YOUR_NEW_HOME,
  RoutePath.FINAL_DETAILS,
  RoutePath.THANK_YOU,
];

const PAGE_TITLES: Record<string, string> = {};
PAGE_TITLES[RoutePath.HOME] = "Let's Get Started";
PAGE_TITLES[RoutePath.YOUR_LAND] = "Your Land";
PAGE_TITLES[RoutePath.CHOOSE_FLOOR_PLAN] = "Choose A Floorplan";
PAGE_TITLES[RoutePath.PACKAGE_SEARCH] = "Find A House & Land Package";
PAGE_TITLES[RoutePath.PACKAGE_SEARCH_RESULTS] = "House & Land Packages";
PAGE_TITLES[RoutePath.CHOOSE_EXTERIOR_STYLE] = "Choose Your Exterior Style";
PAGE_TITLES[RoutePath.INTERIOR_STYLE] = "Choose Your Interior Style";
PAGE_TITLES[RoutePath.PROMOTIONS] = "Promotions";
PAGE_TITLES[RoutePath.PERSONALISE_HOME] = "Personalise Your Home";
PAGE_TITLES[RoutePath.SIGN_UP] = "Sign Up";
PAGE_TITLES[RoutePath.UPGRADE_OPTIONS] = "Upgrade Options";
PAGE_TITLES[RoutePath.TURN_KEY_INCLUSIONS] = "Turn Key Inclusions";
PAGE_TITLES[RoutePath.LIFESTYLE_OPTIONS] = "Additional Lifestyle Options";
PAGE_TITLES[RoutePath.SPECIAL_OFFERS] = "Special Offers";
PAGE_TITLES[RoutePath.FINAL_DETAILS] = "Final Details";
PAGE_TITLES[RoutePath.YOUR_NEW_HOME] = "Complete";
PAGE_TITLES[RoutePath.THANK_YOU] = "Thank You";

export function getPageTitle(route: string): string {
  if (PAGE_TITLES[route] !== undefined) {
    return PAGE_TITLES[route];
  } else {
    return "";
  }
}
